import { useMediaQuery } from '../useMediaQuery';

export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Hook CENTRAL de movimiento. Toda animacion del sitio pasa por aqui.
 *
 * CONTRATO (regla dura del proyecto):
 *   activado -> se APAGA la animacion, NUNCA se esconde contenido.
 * Es decir: un `Reveal` con movimiento reducido renderiza su contenido visible
 * y quieto desde el primer frame. Jamas `opacity: 0` esperando un trigger.
 */
export function useReducedMotion(): boolean {
  return useMediaQuery(REDUCED_MOTION_QUERY);
}
